export default "__VITE_ASSET__b429f869__"